import { GetUser } from "../../utils/sessions";

export const buildParameter = {
  SaveDetail: (id, formdata, listModule) => {
    const arrModule = [];

    const findModuleID = (ModuleName) => {
      var ID = "";
      listModule.forEach((item) => {
        if (item.MODULE_NAME === ModuleName) {
          ID = item.ID;
          return;
        }
      });
      return ID;
    };

    formdata.ListModule.forEach((key) =>
      arrModule.push({
        ID: findModuleID(key),
        MODULE_NAME: key,
      })
    );

    let param = {
      ROLE_ID: id,
      MODULES: arrModule,
      SESSION_OWNER: GetUser(),
    };
    return param;
  },
};
